import { getSidebarCollapsed } from 'gcs-common/slices/uiState/uiStateSelectors';
import { useSelector } from 'react-redux';
import ChannelListItemCollapsed from '../ChannelListItemCollapsed/ChannelListItemCollapsed';
import ChannelListItemNormalWithId from '../ChannelListItemNormalWithId/ChannelListItemNormalWithId';

interface ChannelListItemProps {
  channelId: string;
}

const ChannelListItem = (props: ChannelListItemProps) => {
  const { channelId } = props;
  const sidebarCollapsed = useSelector(getSidebarCollapsed);
  if (sidebarCollapsed) {
    return <ChannelListItemCollapsed channelId={channelId} />;
  }

  return <ChannelListItemNormalWithId channelId={channelId} />;
};

export default ChannelListItem;
